const v2 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        topVideosTable: {
          ...state.options.tableViews.topVideosTable,
          Rpm: false,
        },
      },
    },
  };
};

export default v2;
